import type { VaultApy, VaultApyComposite, VaultApyRange } from '@/types/apy'
import { formatDate, formatDecimalToPercentage, fromUnixTimestamp } from '@vaultsfyi/common/utils'

export function getApyTypeKey({ includeRewards }: { includeRewards: boolean }) {
  return includeRewards ? 'total' : 'base'
}

export function getApyValue({
  apy,
  apyRange,
  includeRewards,
  apyComposite,
}: { apy: VaultApy; apyRange: VaultApyRange; includeRewards: boolean; apyComposite?: VaultApyComposite }) {
  const apyKey = getApyTypeKey({ includeRewards })

  return apyComposite ? apyComposite.totalApy[apyRange][apyKey] : apy[apyRange][apyKey]
}

export function getApyCopy({
  apy,
  apyRange,
  includeRewards,
  apyComposite,
}: { apy: VaultApy; apyRange: VaultApyRange; includeRewards: boolean; apyComposite?: VaultApyComposite }) {
  return formatDecimalToPercentage(getApyValue({ apy, apyRange, includeRewards, apyComposite }))
}

const APY_CAP = 10

export function getCappedApyCopy({
  apy,
  apyRange,
  includeRewards,
  apyComposite,
}: { apy: VaultApy; apyRange: VaultApyRange; includeRewards: boolean; apyComposite?: VaultApyComposite }) {
  const value = getApyValue({ apy, apyRange, includeRewards, apyComposite })
  if (value > APY_CAP) return '>1000%'
  return formatDecimalToPercentage(value)
}

export function getApyRangeCopy(apyRange: VaultApyRange) {
  switch (apyRange) {
    case '1day':
      return { full: '1 day', compact: '1d' }
    case '7day':
      return { full: '7 days', compact: '7d' }
    case '30day':
      return { full: '30 days', compact: '30d' }
  }
}

export function formatApyTimestamp(timestamp: number): string {
  return formatDate({
    timestamp: fromUnixTimestamp(timestamp),
    showYear: true,
    showTime: true,
    options: { timeZone: 'UTC', timeZoneName: 'short' },
  })
}
